/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { StaticSidebarId } from 'cio/services/sidebar';

interface Args {
  name: string;
  sidebarVisible: boolean;
  toggleSidebar: () => unknown;
}

export default class ConditionBlockItemSidebar extends Component<Args> {
  sidebarId = StaticSidebarId.CampaignTrigger;
}
